import React, { 
  //useState 
} from 'react';


import components from "../components"
import Fallback from "../fallback"
import { generateBackground } from '../utils/utils'

import {
  Grid,
  Segment,
} from 'semantic-ui-react';

export default function ContentCardHorizontal(props) {
  //console.debug('ContentCardHorizontal - props', props);

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  const {
    variationType,
    divided,
    centered,
    verticalAlign,
    imageAlign,
    commonPageSection,
    contentCollection,
  } = props;

  const { backgroundColor, backgroundImage, backgroundSize, backgroundPosition, textColor, textAlign } = commonPageSection;

  const columnBackground = generateBackground(backgroundColor, backgroundImage);
  //console.debug('columnBackground', columnBackground);

  const ImageColumnComponent = () => {
    return (
      <Grid.Column width={8}
        style={{ background: columnBackground, backgroundSize: backgroundSize, backgroundPosition: backgroundPosition, }}
      >
        <Segment basic></Segment>
      </Grid.Column>
    )
  }

  const ContentColumnComponent = () => {
    return (
      <Grid.Column width={8}
        textAlign={textAlign ? textAlign : null}
        style={{ color: (textColor !== null ? textColor : null), backgroundColor: (backgroundColor !== null ? backgroundColor : null) }}
      >
         <Segment basic>
          {contentCollection && contentCollection.contentItems.length !== 0 && contentCollection.contentItems.map((block, i) => {
              const { contentType } = block
              //console.debug('column - contentType', contentType);
              const Component = components[contentType] || Fallback
              return <Component key={i} renderSource={props.contentType} {...block} />
            })}
         </Segment>
      </Grid.Column>
    )
  }
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <Grid stretched stackable className={'site-content-card-horizontal ' + (variationType ? variationType : null)}
        divided={divided && divided !== 'false' ? divided : null}
        centered={centered}
        verticalAlign={verticalAlign ? verticalAlign : null}
      >
        <Grid.Row reversed={imageAlign === 'right' ? 'mobile vertically' : null}>
          {imageAlign === 'left' ?
            <>
              <ImageColumnComponent />
              <ContentColumnComponent />
            </>
          :
            <>
              <ContentColumnComponent />
              <ImageColumnComponent />
            </>
          }
        </Grid.Row>
      </Grid>
    </>
  )
}
